import React from "react";
import ContractsListComponent from "../../components/ContractsList/ContractsList.component";
import "./Contracts.css"
const ContractsContainer= (props)=>{
    return (
        <div className="companies-list"><ContractsListComponent  {...props}></ContractsListComponent></div>
    )
}

export default ContractsContainer;
